import { render, staticRenderFns } from "./ECProductDetail.vue?vue&type=template&id=426cf59d&scoped=true&"
import script from "./ECProductDetail.vue?vue&type=script&lang=js&"
export * from "./ECProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ECProductDetail.vue?vue&type=style&index=0&id=426cf59d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426cf59d",
  null
  
)

export default component.exports